angular.module('ihestiaCommonDirectives.configHelper')
  /**
   *
   * @returns {_L5.ConfigService}ustawienia
   */
  .provider('ihestiaConfigHelper', ['$windowProvider', function($windowProvider) {
    // magiczna brzydka funkcja do ogarniania błędów z brakiem konfiguracji
    // musi być tak, gdyż bez konfiguracji nic nam nie będzie działać
    var errorFunc = function() {
      angular.element('.block-ui-wrapper').remove();
      angular.element('.app-content .container').html('<div class="login-wrapper">    <div class="login">        <div class="login-body">            <div class="panel panel-prism panel-shadow">                <div class="panel-body">                    <div class="panel panel-white">                        <div class="panel-body">                            <div class="login-header">                                <div class="login-header-title">                                    <h3>                                        iHestia                                    </h3>                                </div>                                <div class="login-header-logo">                                    <i class="icon-solo icon-ergo">                                    </i>                                    <i class="icon-solo icon-hestia">                                    </i>                                </div>                            </div>                        </div>                        <div class="panel-body">                            <div class="alert alert-danger">                                <i class="icon-solo icon-delete">                                </i>                                <p>                                    Błąd pobierania konfiguracji. Odśwież stronę - jeśli błąd będzie się powtarzać skontaktuj się z administratorem.                                </p>                            </div>                            <div>                                <div class="separator double">                                </div>                                <div class="text-right">                                    <button class="btn btn-primary" onclick="window.location.reload()" type="button">                                        <span>                                            Odśwież                                        </span>                                    </button>                                </div>                            </div>                        </div>                    </div>                </div>                <div class="prism prism-lg">                    <div class="prism-item bg-ogien">                    </div>                    <div class="prism-item bg-kradziez">                    </div>                    <div class="prism-item bg-oczp">                    </div>                    <div class="prism-item bg-nnw">                    </div>                    <div class="prism-item bg-ac">                    </div>                    <div class="prism-item bg-nnwkip">                    </div>                    <div class="prism-item bg-oc">                    </div>                </div>                <div class="poweredby">                    <i class="icon-solo icon-poweredby">                    </i>                </div>            </div>        </div>    </div></div>');
    };
    //w konfiguracji nie mamy jeszcze handlera do błędów
    if (typeof APP_CONFIG === 'undefined') {
      errorFunc();
      throw new Error('APP_CONFIG is not defined. Check config request.');
    }
    if (!angular.isObject(APP_CONFIG)) { //eslint-disable-line no-undef
      errorFunc();
      throw new Error('APP_CONFIG is not an object. Check config request.');
    }

    if (typeof APP_CONFIG.labels === 'undefined') { //eslint-disable-line no-undef
      errorFunc();
      throw new Error('APP_CONFIG.labels is not defined. Check labels request.');
    }
    if (!angular.isObject(APP_CONFIG.labels)) { //eslint-disable-line no-undef
      errorFunc();
      throw new Error('APP_CONFIG.labels is not an object. Check labels request.');
    }


    var configData = APP_CONFIG; //eslint-disable-line no-undef

    var ConfigService = function() {
      var self = this;

      /**
       * Pobieramy zapisaną konfigurację
       * @param  {string|undefined} context [description]
       * @param  {string|undefined} code    [description]
       * @return {mixed}         [description]
       */
      self.get = function(context, code) {
        var response = configData;
        // sprawdzamy, czy podano kontekst
        if (angular.isString(context)) {
          // sprawdzamy, czy kontekst istnieje, jesli nie, to zwracamy null
          if (angular.isDefined(response[context])) {
            response = response[context];
            // sprawdzamy, czy podano kod
            if (angular.isString(code)) {
              // skoro podano kod, to sprawdzamy, czy istnieje w kontekscie, jesli nie, to zwracamy null
              if (angular.isObject(response) && angular.isDefined(response[code])) {
                response = response[code];
              } else {
                response = null;
              }
            }
          } else {
            response = null;
          }
        }

        // poniższe nie angularowo ze względu na optymalizację
        return JSON.parse(JSON.stringify(response)); //eslint-disable-line
      };

      /**
       * Zwraca adres url z '/' na końcu, jeśli jest to "goły" adres
       * Zwracany adres jest względnym, jeśli pochodzi z tej samej domeny
       *
       * @param  {string} urlCode PORTAL_URL|E7_URL|...
       * @param  {string} postfix string do konkatenacji z urlem
       * @param {string|undefined} context (źródło ustawień, domyślnie 'external')
       * @return {string}         url
       */
      self.getUrl = function(urlCode, postfix, context) {
        var url = configServiceInstance.get(context ? context : 'external', urlCode);
        if(!url) {
          throw new Error('No url for code: ' + urlCode); // nie przez error handler, gdyż mamy circular depedency
        }
        postfix = postfix ? postfix : '';
        if(url.split('/').length - 1 < 3) {
          url = url + '/';
        }

        var windowInstance = $windowProvider.$get();

        // jesli adres, do którego kierujemy, to ten sam host, to zwracamy tylko link względny
        if (url.indexOf(windowInstance.location.origin) === 0) {
          url = url
            .replace(windowInstance.location.origin, '');
          if(postfix.indexOf('external/') === 0) {
            postfix = postfix.replace('external/', '#/'); // skoro to link względny, to nie external, a #
          }
        }

        return url + postfix;
      };

      /**
       * Deprecated!
       */
      self.getExternalUrl = function() {
        throw new Error('Method getExternalUrl no longer exists from version 1.4.3 - use getUrl instead!');
      };

    };

    var configServiceInstance = new ConfigService();

    /**
     * Metoda dostępna w sekcji .config
     * @return {ConfigService} [description]
     */
    this.getConfigHelper = function() {
      return configServiceInstance;
    };

    /**
     * return injectora
     * @return {ConfigService} [description]
     */
    this.$get = [
      function() {
        return configServiceInstance;
      }];
  }]);